import { baseApi } from './baseApi';

export interface ClientVersion {
  version: string;
  download_url: string;
  checksum: string;
  signature: string;
  signature_algorithm: string;
  release_date: string;
  changelog: string;
  min_supported_version: string;
  is_critical: boolean;
  requires_restart: boolean;
  file_size?: number;
  is_deleted?: boolean;
  deleted_at?: string;
}

export interface UploadResponse {
  message: string;
  version: string;
  checksum: string;
  signature: string;
  file_size: number;
  storage_path: string;
}

export const clientUpdatesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getClientVersions: builder.query<Record<string, ClientVersion>, void>({
      query: () => '/client-updates/versions',
      providesTags: [{ type: 'ClientUpdate', id: 'LIST' }],
    }),

    getLatestClientVersion: builder.query<ClientVersion, void>({
      query: () => '/client-updates/latest',
      providesTags: [{ type: 'ClientUpdate', id: 'LATEST' }],
    }),

    uploadClientVersion: builder.mutation<
      UploadResponse,
      { version: string; file: File; changelog: string; isCritical?: boolean }
    >({
      query: ({ version, file, changelog, isCritical = false }) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: `/client-updates/upload/${version}`,
          method: 'POST',
          params: { changelog, is_critical: isCritical },
          body: formData,
        };
      },
      invalidatesTags: [
        { type: 'ClientUpdate', id: 'LIST' },
        { type: 'ClientUpdate', id: 'LATEST' },
      ],
    }),

    deleteClientVersion: builder.mutation<{ message: string }, string>({
      query: (version) => ({
        url: `/client-updates/versions/${version}`,
        method: 'DELETE',
      }),
      invalidatesTags: [
        { type: 'ClientUpdate', id: 'LIST' },
        { type: 'ClientUpdate', id: 'LATEST' },
      ],
    }),
  }),
});

export const {
  useGetClientVersionsQuery,
  useGetLatestClientVersionQuery,
  useUploadClientVersionMutation,
  useDeleteClientVersionMutation,
} = clientUpdatesApi;
